import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import APIKeyModal from '../APIKeyModal/APIKeyModal';
import { CardHandler } from '../APIKeyPM/APIKeyPM.utils';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import KarbonLogo from './KarbonLogo';
export const GetKarbonCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            KarbonCardTID: {
                Card: 'karbon-card',
                Connect: 'karbon-card-connect'
            }
        }
    });
const KarbonCard = (param)=>{
    let { integration } = param;
    const { t: karbonTexts } = useLocaleKeys('integrations.availableApps.karbon');
    const { KarbonCardTID } = useMemo(()=>GetKarbonCardTID(), []);
    const navigate = useNavigate();
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    const { refresh: refreshIntegrations } = useIntegrations({
        enabled: false
    });
    const ui = {
        goToPage: (page)=>navigate(page),
        requestApiKey: (apiKeyListener)=>overlayContext.showModal({
                biName: 'api_key_modal',
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(APIKeyModal, {
                        pmName: PracticeManagement.Karbon,
                        dismissModal: dismissModal,
                        apiKeyListener: apiKeyListener
                    });
                }
            }),
        refetchIntegrations: async ()=>{
            await refreshIntegrations({
                throwOnError: false
            });
        }
    };
    const server = {
        saveApiKey: async (apiKey)=>api.karbon.setAPIKey(apiKey)
    };
    const karbonCardHandler = new CardHandler(ui, integration, server);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: KarbonCardTID.Card(),
        title: karbonTexts.title(),
        subTitle: karbonTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_karbon'
            },
            testId: KarbonCardTID.Connect(),
            onClick: ()=>karbonCardHandler.handleClick(routes.karbonSetup),
            children: karbonCardHandler.getActionText()
        }),
        icon: /*#__PURE__*/ _jsx(KarbonLogo, {})
    });
};
export default KarbonCard;
